import { render } from "./FeatureTriple.vue?vue&type=template&id=0e09c59f"
import script from "./FeatureTriple.vue?vue&type=script&lang=js"
export * from "./FeatureTriple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/FeatureHighlight/FeatureTriple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e09c59f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e09c59f', __exports__)) {
    api.reload('0e09c59f', __exports__)
  }
  
  module.hot.accept("./FeatureTriple.vue?vue&type=template&id=0e09c59f", () => {
    api.rerender('0e09c59f', render)
  })

}


export default __exports__